import { memo } from "react";
import styled from "styled-components";
import Rect from "./Rect";
const Select = /*#__PURE__*/memo(styled(Rect).withConfig({
  displayName: "Select",
  componentId: "sc-19145hx-0"
})(["pointer-events:none;"]));
export default Select;
//# sourceMappingURL=Select.js.map